<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useAsyncState } from '@vueuse/core';

// Access store via proxy
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// Computed:formData (replaces standard computed)
const formData = computed(() => {
    return store.state.printGiftsReports.formData;
});

// Async Logic: categories (replaces asyncComputed)
const { state: categories } = useAsyncState(
    store.dispatch('request/get', {
        url: 'api/component/m_products_categories',
        params: {
            parentId: 0,
            fields: ['id', 'title'],
            sort: 'title'
        }
    }).then(o => o.data.items),
    [] // Initial state as empty array to prevent v-for errors
);
</script>

<template>
    <select v-model="formData.primaryCategory" class="form-select form-select-sm" name="primaryCategory" required>
        <option :value="0">- All -</option>
        <option v-for="category in categories" :key="category.id" :value="category.id">
            {{ category.title }}
        </option>
    </select>
</template>